import {
  EntityLinks,
  Goal,
  GoalFilterDocument,
  GoalProgressCount,
  GoalSortingMode,
  GoalType,
  ID,
  Timestamp,
  WeekDays,
} from '@griply/types';

import { sortGoals } from '../sort-goals';
import { filterGoalsByFilterDocument } from './filter-goals-by-filter-document';
import { filterGoalsByType } from './filter-goals-by-type';
import { sortGoalsHierarchically } from './sort-goals-hierarchically';

export type ProcessGoalsByFilterDocumentOptions = {
  customOrder?: ID[];
  today: Timestamp;
  weekStartsOn: WeekDays;
  taskCounts?: Map<ID, number>;
  goalProgressCounts?: Map<ID, GoalProgressCount>;
  goalTypeFilter?: GoalType[];
  links: EntityLinks;
};

// `baseSortedGoals` is both the filter input and the `allGoals` sort context.
export const processGoalsByFilterDocument = (
  baseSortedGoals: Goal[],
  filterDocument: GoalFilterDocument | undefined,
  {
    customOrder,
    today,
    weekStartsOn,
    taskCounts,
    goalProgressCounts,
    goalTypeFilter,
    links,
  }: ProcessGoalsByFilterDocumentOptions,
): Goal[] => {
  const filtered = filterGoalsByFilterDocument(
    baseSortedGoals,
    filterDocument,
    {
      today,
      weekStartsOn,
      links,
    },
  );

  const ordered = customOrder?.length
    ? sortGoalsHierarchically(filtered, customOrder, { links })
    : sortGoals(filtered, {
        allGoals: baseSortedGoals,
        sortMode: filterDocument?.sortingMode ?? GoalSortingMode.StartDate,
        customOrder,
        taskCounts,
        goalProgressCounts,
        links,
      });

  // Type filter runs last — the document's filters walk the parent chain, so a
  // project only resolves in while its parent goal is still present.
  return goalTypeFilter ? filterGoalsByType(ordered, goalTypeFilter) : ordered;
};
